import { z } from "zod";

export const searchQuerySchema = z
	.object({
		q: z.string().min(2).max(100),
		limit: z.coerce.number().int().min(1).max(20).default(5),
	})
	.strict();

export type SearchQueryPayload = z.infer<typeof searchQuerySchema>;
